import { formatearMoneda, type Boveda } from '@barbones/shared';
import { useSesion } from '@/api/sesion';
import { Campo, Select } from '@/components/ui/form';
import { useSaldos } from './BovedaPage';

/** «Pagar desde»: la bóveda de la que sale un pago (con su saldo, si se puede ver). */
export function SelectorBoveda({ valor, onCambiar }: { valor: Boveda | ''; onCambiar: (b: Boveda) => void }) {
  const { puede } = useSesion();
  const saldos = useSaldos(puede('boveda.ver')).data;
  const saldo = (b: Boveda) => (saldos ? ` · ${formatearMoneda(saldos[b].MXN)}` : '');
  return (
    <Campo etiqueta="Pagar desde" requerido>
      {(p) => (
        <Select {...p} value={valor} onChange={(e) => onCambiar(e.target.value as Boveda)}>
          <option value="" disabled>
            Elige la bóveda
          </option>
          <option value="efectivo">{`Efectivo (caja fuerte)${saldo('efectivo')}`}</option>
          <option value="banco">{`Banco${saldo('banco')}`}</option>
        </Select>
      )}
    </Campo>
  );
}
